import { isNil } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './MoneyMarketEventMessage.scss';

import { getMoneyMarketEventGlobalMessage } from '../../../redux/modules/moneyMarketEvent/moneyMarketEvent.selectors';
import If from '../../Shared/If/If';

class MoneyMarketEventMessage extends Component {
  render() {
    const {
      a_href: aHref,
      a_target: aTarget,
      a_text: aText,
      span_class: spanClass,
    } = this.props.moneyMarketEventGlobalMessage || {};
    const showContainer =
      !isNil(aHref) && !isNil(aTarget) && !isNil(aText) && !isNil(spanClass);
    return (
      <If test={showContainer}>
        <div className={`money-market-message-container`}>
          <span className={spanClass}>
            <a href={aHref} target={aTarget}>
              {aText}
            </a>
          </span>
        </div>
      </If>
    );
  }
}

const mapStateToProps = (state) => ({
  moneyMarketEventGlobalMessage: getMoneyMarketEventGlobalMessage(state),
});

export default compose(connect(mapStateToProps))(MoneyMarketEventMessage);
